import { lazy } from "react";

const LayersPage = lazy(() => import("src/pages/layers/layers"));

export const layersRoutes = [
  {
    path: "layers",

    element: <LayersPage />,
  },
];
